import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { LegalLang } from '../../shared/legal-lang-toggle/legal-lang-toggle.component';

/** Public, mobile-product-only pricing preview served at /pricing. */
@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  standalone: false,
})
export class PricingComponent implements OnInit {
  lang: LegalLang = 'en';

  constructor(private titleService: Title, private route: ActivatedRoute) { }

  ngOnInit() {
    if (this.route.snapshot.queryParamMap.get('lang') === 'fr') this.lang = 'fr';
    this.setTitle();
  }

  onLangChange(lang: LegalLang) {
    this.lang = lang;
    this.setTitle();
  }

  private setTitle() {
    const page = this.lang === 'fr' ? 'Tarification de Replay' : 'Replay Pricing';
    this.titleService.setTitle(`${page} | ${environment.appName}`);
  }
}
